import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { TaskFilterParam } from '../tasks';

export type UseGetTasksStatsParams = {
  filters: TaskFilterParam;
};

export type UseGetTasksStatsProps = {
  params: UseGetTasksStatsParams;
  enabled?: boolean;
};

export interface TasksStatsResponse {
  task_overdue: number;
  task_due_today: number;
}

const fetchDashboardTasksStats = async ({ params }: UseGetTasksStatsProps) => {
  const response = await CustomAxios.get<TasksStatsResponse>('dashboard/tasks-stats', { params });
  return response.data;
};

export function useGetDashboardTasksStats({ params, enabled = true }: UseGetTasksStatsProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.dashboardTasks, params],
    queryFn: () => fetchDashboardTasksStats({ params }),
    placeholderData: keepPreviousData,
  });
}
